module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This edition first published in 2022")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("by Birlinn Limited")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("West Newington House")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 Newington Road")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EH9 1QS")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.birlinn.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © Lilly Hurd 2022")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The moral right of Lilly Hurd to"), _c('br'), _vm._v("be identified as the author of this work"), _c('br'), _vm._v("has been asserted by her in accordance"), _c('br'), _vm._v("with the Copyright, Designs and"), _c('br'), _vm._v("Patents Act 1988")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Designed and typeset by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Mark Blackadder")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/pub.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed and bound by Bell & Bain Ltd, Glasgow")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0